import { RouteComponentProps } from 'react-router';
import { withTranslation, WithTranslation } from 'react-i18next';
import { discountRuleEditRoles, DiscountRuleFilters, DiscountRuleModel } from '../../../../api/pricing/pricing.types';
import { DATE_FORMAT, defaultPageSize, PageRequest } from '../../../../api/api.types';
import { BrokerRateModel, CarClassModel, DeskModel, ProductModel } from '../../../../api/core/core.types';
import { UserModel } from '../../../../api/authentication/authentication.types';
import dayjs, { Dayjs } from 'dayjs';
import React, { FormEvent } from 'react';
import { AppState } from '../../../../store/store.types';
import { ThunkDispatch } from 'redux-thunk';
import { getDeskList } from '../../../setup/actions/desk.actions';
import { connect } from 'react-redux';
import { getBrokerRateList } from '../../../setup/actions/brokerrate.actions';
import { getDiscountRulesList, updateDiscountRuleFilters } from '../../actions/discountrule.actions';
import { DiscountRuleActionTypes } from '../../types/discountrule.types';
import { getProductList } from '../../../setup/actions/product.actions';
import StatusLabel from '../../../../components/forms/StatusLabel';
import { userCanAccessComponent } from '../../../../helpers/authentication.helper';
import { Link } from 'react-router-dom';
import DatePicker from '../../../../components/forms/DatePicker';
import Select from '../../../../components/forms/Select';
import { UncontrolledTooltip as Tooltip } from 'reactstrap';
import infoIcon from '../../../../assets/img/info-circle.svg';
import { getAllCarClasses } from '../../../core/actions/carClass.actions';
import { formatDate } from '../../../../helpers/date.helper';
import ListViewTable from '../../../../components/tables/ListViewTable';
import { SupplierBrokerModel } from '../../../../api/admin/admin.types';
import { getSupplierBrokerList } from '../../../admin/actions/supplierbroker.actions';

interface DiscountRuleProps extends RouteComponentProps, WithTranslation {
  getDiscountRulesList: (filters?: DiscountRuleFilters, page?: PageRequest) => Promise<void>;
  getAllCarClasses: () => void;
  getDeskList: () => void;
  getBrokerList: () => void;
  getProductList: () => void;
  getBrokerRateList: () => void;
  updateFilters: (filters: DiscountRuleFilters) => void;
  discountRules: DiscountRuleModel[] | null;
  desks: DeskModel[];
  products: ProductModel[];
  brokers: SupplierBrokerModel[];
  carClasses: CarClassModel[];
  brokerRates: BrokerRateModel[];
  user: UserModel | null;
  totalElements: number;
  totalPages: number;
  filters: DiscountRuleFilters | null;
}

interface DiscountRuleState {
  selectedPageNumber: number;
  sortOrder: 'ASC' | 'DESC';
  sortedBy: string;
  filtersUpdated: boolean;
  filter: {
    pickupDateFilter: {
      value: Dayjs | undefined;
    };
    deskFilter: {
      value: [] | { label: string; value: string };
    };
    brokerFilter: {
      value: [] | { label: string; value: string };
    };
  };
}

const DiscountRulesSortFields = [
  { value: 'pickupFrom', label: 'pickupFrom' },
  { value: 'requestFrom', label: 'requestFrom' }
];

class DiscountRules extends React.Component<DiscountRuleProps, DiscountRuleState> {
  constructor(props: DiscountRuleProps) {
    super(props);
    this.state = {
      selectedPageNumber: 1,
      sortOrder: 'DESC',
      sortedBy: 'id',
      filtersUpdated: false,
      filter: {
        pickupDateFilter: {
          value: undefined
        },
        deskFilter: {
          value: []
        },
        brokerFilter: {
          value: []
        }
      }
    };
  }

  componentDidMount() {
    this.updateFilterValues();
    this.props.getAllCarClasses();
    this.props.getDeskList();
    this.props.getBrokerRateList();
    this.props.getBrokerList();
    this.props.getDiscountRulesList(this.props?.filters ?? undefined);
  }

  componentDidUpdate() {
    if (!this.state.filtersUpdated) {
      this.updateFilterValues();
    }
  }

  updateFilterValues = () => {
    const filters = this.props.filters;
    if (filters) {
      const desks = filters.desks ? filters.desks.split(',') : undefined;
      const brokers = filters.brokers ? filters.brokers.split(',') : undefined;

      const selectedDeskOptions: { value: string; label: string }[] = [];
      if (desks && desks.length) {
        desks.forEach((sd) => {
          const desk = this.props.desks.find((d) => d.code === sd);
          if (desk) {
            selectedDeskOptions.push({ value: desk.code, label: desk.name });
          }
        });
      }

      const selectedBrokerOptions: { value: string; label: string }[] = [];
      if (brokers && brokers.length) {
        brokers.forEach((sb) => {
          const broker = this.props.brokers.find((b) => b.id === Number(sb));
          selectedBrokerOptions.push({ value: broker ? String(broker.id) : sb, label: broker ? broker.name : sb });
        });
      }


      this.setState({
        selectedPageNumber: filters.pageNumber ? filters.pageNumber : 1,
        filtersUpdated: true,
        filter: {
          pickupDateFilter: {
            value: filters.pickupDate ? dayjs(filters.pickupDate) : undefined
          },
          deskFilter: {
            value: selectedDeskOptions[ 0 ]
          },
          brokerFilter: {
            value: selectedBrokerOptions[ 0 ]
          }
        }
      }, () => {
        const filtersapl = this.composeFilters();
        this.props.getDiscountRulesList(filtersapl);
      });
    }
  };

  clearFilters = () => {
    this.setState({
      selectedPageNumber: 1,
      filter: {
        pickupDateFilter: {
          value: undefined
        },
        deskFilter: {
          value: []
        },
        brokerFilter: {
          value: []
        }
      }
    });

    const filters = this.composeFilters();
    this.props.updateFilters(filters);
    this.props.getDiscountRulesList();
  };

  pickupFromCell = (props: any) => {
    if (props.row.original.pickupFrom.length > 0) {
      return (
        <div className="numeric-content">
          {`${formatDate(props.row.original.pickupFrom)} - ${formatDate(props.row.original.pickupTo)}`}
        </div>
      );
    }
  };

  requestFromCell = (props: any) => (
    <div className="numeric-content">
      {`${formatDate(props.row.original.requestFrom)} - ${formatDate(props.row.original.requestTo)}`}
    </div>
  );

  rentalDaysCell = (props: any) => {
    if (props.row.original.daysFrom !== null && props.row.original.daysTo !== null) {
      return (
        <div className="numeric-content">
          {`${props.row.original.daysFrom} - ${props.row.original.daysTo}`}
        </div>
      );
    } else {
      return 'Any';
    }
  };

  carClassCell = ({ row }: { row: any }) => {
    const { t } = this.props;

    if (row.original.carClasses.length > 0) {
      const carList: JSX.Element[] = [];
      row.original.carClasses.forEach((carClass: any) => {
        const carObj = this.props.carClasses.find((c) => c.acrissCode === carClass.acrissCode);
        carList.push(
          <div key={carClass.acrissCode}>
            {carObj ? carObj.acrissCode : carClass.acrissCode}
          </div>
        );
      });
      if (row.original.carClasses.length === 1) {
        const carObj = this.props.carClasses.find((d) => d.acrissCode === row.original.carClasses[ 0 ].acrissCode);
        return carObj && carObj.acrissCode || row.original.carClasses[ 0 ].acrissCode;
      }
      return (
        <div>
          <div
            className="btn btn-link font-normal p-0"
            id={`cars-tooltip-${row.original.id}`}
          >
            {t('v.car_classes', { count: row.original.carClasses.length })}
          </div>
          <Tooltip
            modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
            placement="top"
            target={`cars-tooltip-${row.original.id}`}
            autohide={false}
          >
            {carList}
          </Tooltip>
        </div>
      );
    }
    return t('v.all_car_classes');
  };

  deskCell = ({ row }: { row: any }) => {
    const { t } = this.props;

    if (row.original.desks.length > 0) {
      const deskList: JSX.Element[] = [];
      row.original.desks.forEach((desk: any) => {
        const deskObj = this.props.desks.find((d) => d.code === desk.code);
        deskList.push(<div key={desk.deskCode}>{deskObj ? deskObj.name : desk.code}</div>);
      });

      if (row.original.desks.length === 1) {
        const deskObj = this.props.desks.find((d) => d.code === row.original.desks[ 0 ].code);
        return deskObj && deskObj.name || row.original.desks[ 0 ].code;
      }
      return (
        <div>
          <div
            className="btn btn-link font-normal p-0"
            id={`desks-tooltip-${row.original.id}`}
          >
            {t('v.desks', { count: row.original.desks.length })}
          </div>
          <Tooltip
            modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
            placement="top"
            target={`desks-tooltip-${row.original.id}`}
            autohide={false}
          >
            {deskList}
          </Tooltip>
        </div>
      );
    }
    return t('v.all_desks');
  };

  productCell = ({ row }: { row: any }) => {
    const { t } = this.props;

    if (row.original.products.length > 0) {
      const productList: JSX.Element[] = [];
      row.original.products.forEach((product: any) => {
        const productObj = this.props.products.find((c) => c.code === product.code);
        productList.push(
          <div key={product.productId}>
            {productObj ? productObj.name : product.code}
          </div>
        );
      });
      if (row.original.products.length === 1) {
        const productObj = this.props.products.find((d) => d.id === row.original.products[ 0 ].code);
        return productObj && productObj.name || row.original.products[ 0 ].code;
      }
      return (
        <div>
          <div
            className="btn btn-link font-normal p-0"
            id={`products-tooltip-${row.original.id}`}
          >
            {t('v.discount_rules.products', { count: row.original.products.length })}
          </div>
          <Tooltip
            modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
            placement="top"
            target={`products-tooltip-${row.original.id}`}
            autohide={false}
          >
            {productList}
          </Tooltip>
        </div>
      );
    }
    return t('v.discount_rules.all_products');
  };

  brokerCell = ({ row }: { row: any }) => {
    const { t } = this.props;

    if (row.original.brokers.length === 1) {
      const brokerObj = this.props.brokers.find((d) => d.id === row.original.brokers[ 0 ].id);
      return brokerObj && brokerObj.name || row.original.brokers[ 0 ].id;
    }
    if (row.original.brokers.length > 0) {
      const brokerList: JSX.Element[] = [];
      row.original.brokers.forEach((broker: any) => {
        const brokerObj = this.props.brokers.find((c) => c.id === broker.id);
        brokerList.push(
          <div key={broker.id}>
            {brokerObj ? brokerObj.name : broker.id}
          </div>
        );
      });
      return (
        <div>
          <div
            className="btn btn-link font-normal p-0"
            id={`brokers-tooltip-${row.original.id}`}
          >
            {t('v.discount_rules.brokers', { count: row.original.brokers.length })}
          </div>
          <Tooltip
            modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
            placement="top"
            target={`brokers-tooltip-${row.original.id}`}
            autohide={false}
          >
            {brokerList}
          </Tooltip>
        </div>
      );
    }
    return t('v.discount_rules.all_brokers');
  };

  brokerRateCell = ({ row }: { row: any }) => {
    const { t } = this.props;

    if (row.original.brokerRates.length === 1) {
      const brokerObj = this.props.brokerRates.find((d) => d.code === row.original.brokerRates[ 0 ].code);
      return brokerObj && brokerObj.code || row.original.brokerRates[ 0 ].code;
    }
    if (row.original.brokerRates.length > 0) {
      const brokerRateList: JSX.Element[] = [];
      row.original.brokerRates.forEach((brokerRate: any) => {
        const brokerObj = this.props.brokerRates.find((c) => c.code === brokerRate.code);
        brokerRateList.push(
          <div key={brokerRate.code}>
            {brokerRate.code}
          </div>
        );
      });
      return (
        <div>
          <div
            className="btn btn-link font-normal p-0"
            id={`broker-rates-tooltip-${row.original.id}`}
          >
            {t('v.discount_rules.broker_rates', { count: row.original.brokerRates.length })}
          </div>
          <Tooltip
            modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
            placement="top"
            target={`broker-rates-tooltip-${row.original.id}`}
            autohide={false}
          >
            {brokerRateList}
          </Tooltip>
        </div>
      );
    }
    return t('v.discount_rules.all_broker_rates');
  };

  statusCell = (props: any) => (<StatusLabel status={props}/>);

  onRowClick = (rowInfo: any) => this.props.history.push(`/rates/discountrules/${rowInfo.original.id}/view`);


  changeHandler = (event: { target: HTMLInputElement }) => {
    const { name, value } = event.target;
    this.setState({
      filter: {
        ...this.state.filter,
        [ name ]: {
          value
        }
      }
    });
  };

  handleUpdateResults = () => {
    const filters = this.composeFilters();
    this.props.getDiscountRulesList(filters);
    this.props.updateFilters(filters);
  };

  composeFilters = () => {
    const date = this.state.filter.pickupDateFilter.value;

    const deskFilterValue: any = this.state.filter.deskFilter.value;
    const brokerFilterValue: any = this.state.filter.brokerFilter.value;


    const filters: DiscountRuleFilters = {
      pickupDate: date ? date.format(DATE_FORMAT) : undefined,
      desks: deskFilterValue ? deskFilterValue.value : undefined,
      brokers: brokerFilterValue ? brokerFilterValue.value : undefined,
      pageNumber: this.state.selectedPageNumber - 1
    };

    return filters;
  };

  onDateChange = (date?: Dayjs) => {
    this.setState({
      filter: {
        ...this.state.filter,
        pickupDateFilter: {
          value: date
        }
      }
    }, () => {
      this.handleUpdateResults();
    });
  };

  getLORHeader = (headerName: string, headerComment: string) => {
    return (
      <div>
        <div>{headerName}
          <img src={infoIcon} className="i-info-icon" id="lor-header-tooltip"/>
        </div>
        <Tooltip
          className="dark-tooltip"
          modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
          placement="right"
          target="lor-header-tooltip"
          autohide={false}
        >
          <div className="d-flex flex-wrap">
            <pre className="dark-tooltip-text">{headerComment}</pre>
          </div>
        </Tooltip>
      </div>
    );
  };

  discountCell = (props: any) => {
    return `${props * 100} %`;
  };


  defineColumns() {
    const { t } = this.props;
    return [
      {
        header: t('ct.discount_rules.pickup_period'),
        accessorKey: 'pickupFrom',
        cell: ({ row }: { row: any }) => this.pickupFromCell({ row }),
        meta: { align: 'right', width: 200, numeric: true }
      },
      {
        header: t('ct.discount_rules.request_period'),
        accessorKey: 'requestFrom',
        cell: ({ row }: { row: any }) => this.requestFromCell({ row }),
        meta: { align: 'right', width: 200, numeric: true }
      },
      {
        header: () => this.getLORHeader(t('ct.discount_rules.rental_days'), t('comment.discount_rule.lor')),
        accessorKey: 'daysFrom',
        cell: ({ row }: { row: any }) => this.rentalDaysCell({ row }),
        meta: { align: 'right', width: 120, numeric: true }
      },
      {
        header: t('ct.discount_rules.discount'),
        accessorKey: 'discountPercentage',
        cell: (info: any) => this.discountCell(info.getValue()),
        style: { textAlign: 'right' },
        headerClassName: 'numeric-column',
        width: 100
      },
      {
        header: t('ct.discount_rules.car_classes'),
        accessorKey: 'carClasses',
        cell: ({ row }: { row: any }) => this.carClassCell({ row })
      },
      {
        header: t('ct.discount_rules.desks'),
        accessorKey: 'desks',
        cell: ({ row }: { row: any }) => this.deskCell({ row })
      },
      {
        header: t('ct.discount_rules.products'),
        accessorKey: 'products',
        cell: ({ row }: { row: any }) => this.productCell({ row })
      },
      {
        header: t('ct.discount_rules.brokers'),
        accessorKey: 'brokers',
        cell: ({ row }: { row: any }) => this.brokerCell({ row })
      },
      {
        header: t('ct.discount_rules.broker_rates'),
        accessorKey: 'brokerRates',
        cell: ({ row }: { row: any }) => this.brokerRateCell({ row })
      },
      {
        header: t('ct.discount_rules.status'),
        accessorKey: 'statusType',
        cell: (info: any) => this.statusCell(info.getValue()),
        style: { paddingTop: '6px' }
      }
    ];
  }

  dropdownChange = (newValue: any, field: string) => {
    this.setState({
      filter: {
        ...this.state.filter,
        [ field ]: {
          value: newValue
        }
      }
    }, () => {
      this.handleUpdateResults();
    });
  };

  onFilterClick = (e: FormEvent) => {
    e.preventDefault();
    const filters = this.composeFilters();
    this.props.getDiscountRulesList(filters);
    this.props.updateFilters(filters);
  };

  sortBy = (columnName: string, sortDirection: 'ASC' | 'DESC') => {
    console.log(columnName);
    const sortFieldName = DiscountRulesSortFields.find((column) => column.value === columnName);
    if (!sortFieldName) {
      return;
    }
    this.setState({ sortOrder: sortDirection, sortedBy: sortFieldName.label });
    return (
      this.props.getDiscountRulesList(this.composeFilters(), {
        page: this.state.selectedPageNumber - 1,
        size: defaultPageSize,
        sortField: sortFieldName.label,
        sortDirection: sortDirection
      })
    );
  };

  getDataFn(pageRequest: PageRequest) {
    if (pageRequest.page !== undefined && pageRequest.sortDirection !== undefined) {
      const pageRequestFix = {
        page: pageRequest.page,
        sortDirection: pageRequest.sortDirection,
        sortField: DiscountRulesSortFields.find((column) => column.label === pageRequest.sortField)?.label ?? 'id'
      };
      this.props.getDiscountRulesList(this.composeFilters(), pageRequestFix);

      this.setState({
        selectedPageNumber: pageRequestFix.page + 1,
        sortOrder: pageRequestFix.sortDirection ?? 'ASC',
        sortedBy: DiscountRulesSortFields.find((column) => column.label === pageRequest.sortField)?.label ?? 'id'
      });
    }
  }

  render() {
    const { t } = this.props;
    return (
      <main>
        <div className="page-content">
          <div className="d-flex justify-content-between align-items-center">
            <h1>Discount rules</h1>
            {this.props.user && userCanAccessComponent(this.props.user, discountRuleEditRoles) && (
              <Link
                to={{
                  pathname: '/rates/discountrules/create'
                }}
                className="btn btn-primary btn-wide"
              >
                {t('b.add_new').toUpperCase()}
              </Link>
            )}
          </div>
          <form className="d-flex justify-content-between container-fluid filter-container form-group form-inline">
            <div className="d-flex ml-1 row col-10 flex-wrap filters-container">
              <div className="col filter-select filter-item-margin">
                <DatePicker
                  isEdit
                  isFilter
                  date={this.state.filter.pickupDateFilter.value}
                  onChange={(val) => this.onDateChange(val)}
                />
              </div>
              <div className="margins-form-select ml-0">
                <Select
                  value={this.state.filter.deskFilter.value}
                  marginTop
                  placeholder={t('ph.filter.discount_rules.by_location')}
                  elWidth={250}
                  // eslint-disable-next-line no-nested-ternary
                  options={this.props.desks.sort((a, b) => ((a.name < b.name) ? -1 : (a.name > b.name) ? 1 : 0)).map((d) => ({
                    label: d.name,
                    value: d.code
                  }))}
                  onChange={(val) => this.dropdownChange(val, 'deskFilter')}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  label="location"
                />
              </div>
              <Select
                value={this.state.filter.brokerFilter.value}
                equalWidthElement
                className="mr-1"
                marginTop
                placeholder={t('ph.filter.discount_rules.by_broker')}
                // eslint-disable-next-line no-nested-ternary
                options={this.props.brokers.sort((a, b) => ((a.name < b.name) ? -1 : (a.name > b.name) ? 1 : 0)).map((d) => ({
                  label: d.name,
                  value: String(d.id)
                }))}
                onChange={(val) => this.dropdownChange(val, 'brokerFilter')}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                label="brokers"
              />
            </div>
            <div className="col2 pl-1">
              <button type="button" className="btn btn-text-only mr-2" onClick={() => this.clearFilters()}>
                {t('b.clear_filter')}
              </button>
              <button type="submit" className="btn btn-primary filter-button" onClick={this.onFilterClick}>
                {t('b.filter').toUpperCase()}
              </button>
            </div>
          </form>
          {this.props.discountRules
            ? (
              <ListViewTable
                data={this.props.discountRules}
                columns={this.defineColumns()}
                getTrProps={this.onRowClick}
                sortBy={this.sortBy}
                sortOrder={this.state.sortOrder}
                sortedBy={DiscountRulesSortFields.find(({ value, label }) => this.state.sortedBy === label)?.value}
                paginationEnabled={true}
                totalPages={this.props.totalPages}
                totalElements={this.props.totalElements}
                selectedPageNumber={this.state.selectedPageNumber}
                getDataFn={(pageRequest: PageRequest) => this.getDataFn(pageRequest)}
              />
            ) : null}
        </div>
      </main>
    );
  }
}


const mapStateToProps = (state: AppState) => ({
  discountRules: state.rates.discountRules.discountRules,
  desks: state.setup.desks.desks,
  carClasses: state.core.carClasses.acrissCodes,
  products: state.setup.products.products,
  brokers: state.admin.supplierBrokers.supplierBrokers,
  brokerRates: state.core.brokerRates.brokerRates,
  user: state.authentication.user,
  totalPages: state.rates.discountRules.totalPages,
  totalElements: state.rates.discountRules.totalElements,
  filters: state.rates.discountRules.filters
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, DiscountRuleActionTypes>) => ({
  getDiscountRulesList: (filters?: DiscountRuleFilters, pageRequest?: PageRequest) => dispatch(getDiscountRulesList(filters, pageRequest)),
  getDeskList: () => dispatch(getDeskList()),
  getAllCarClasses: () => dispatch(getAllCarClasses()),
  getBrokerList: () => dispatch(getSupplierBrokerList()),
  getBrokerRateList: () => dispatch(getBrokerRateList()),
  getProductList: () => dispatch(getProductList()),
  updateFilters: (filters: DiscountRuleFilters) => dispatch(updateDiscountRuleFilters(filters))
});
export default withTranslation()(connect(
  mapStateToProps,
  mapDispatchToProps
)(DiscountRules));